import { Script } from 'gatsby';
import { TheContext } from '~components/TheContext';
import { GTM_URL } from '~globals';
import { isProd, isStaging } from '~utils/env';

export const sharedRoot = (element: React.ReactElement) => {
  return (
    <TheContext>
      {(isProd || isStaging) && (
        <>
          <Script src={GTM_URL} strategy='idle' />
          <Script id='gtm-init'>
            {`
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ 'platform': 'funnel' });
            window.dataLayer.push({ 'gtm.start': new Date().getTime(), 'event': 'gtm.js' });
          `}
          </Script>
        </>
      )}
      {element}
    </TheContext>
  );
};
